import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddprojectmodalpopupComponent } from '../addprojectmodalpopup/addprojectmodalpopup.component';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-report-config',
  templateUrl: './report-config.component.html',
  styleUrls: ['./report-config.component.scss']
})
export class ReportConfigComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {};
  buttonColorName: any;
  loggedInUserCompanyID: any;
  selectedYearForDWM: any = null;
  loggedInCompanyFiscalyear: any;
  subModuleButtonColor: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  isCurrentYearSelected: boolean = false;
  pmsYears: any = [];
  reportConfigId: number | null = null;

  savedConfig = {
    grades: [] as string[],
    userIds: [] as number[]
  };

  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private snackBar: MatSnackBar,
    private loadingService: LoaderService,
    public dialogRef: MatDialogRef<AddprojectmodalpopupComponent>,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    public mobileResponsiveService: MobileResponsiveService,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      // console.log("fiscal year..", this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  defaultCallFunctionsList() {
    this.getGradeData();
    //  this.getReportConfig();
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.defaultCallFunctionsList();
  }

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;
  }

  // dropdown for Band

  gradeList: any[] = [];
  selectGrade: any[] = [];

  getGradeData() {
    this.httpService.callGetService(`${this.config.getDWMGrades}/${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      this.gradeList = res.data.map((g: string, i: number) => ({
        id: i + 1,
        name: g
      }));

      this.getSavedReportConfig(); // 🔑 chain properly
    });
  }

  getSavedReportConfig() {
    this.httpService.callGetService(`${this.config.getDwmReportConfig}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      if (!res?.data?.length) return;

      const config = res.data[0]; // ONE config assumption

      this.reportConfigId = config.id;
      this.savedConfig.grades = config.grades;
      this.savedConfig.userIds = config.userIds;

      //  preselect grades
      this.selectGrade = this.gradeList.filter(g => this.savedConfig.grades.includes(g.name));

      //  now load employees for those grades
      this.loadEmployeesForGrades();
    });
  }

  loadEmployeesForGrades() {
    if (!this.selectGrade.length) {
      this.employeeList = [];
      this.selectedEmployee = [];
      return;
    }

    const payload = {
      companyId: this.loggedInUserCompanyID,
      grades: this.selectGrade.map(g => g.name)
    };

    this.httpService.callPostService(this.config.getDwmEmployeeNames, payload).subscribe((res: any) => {
      this.employeeList = res.data.map((emp: any) => ({
        id: emp.userId,
        name: `${emp.firstName} ${emp.lastName}`
      }));

      //  preselect employees ONLY if saved config exists
      if (this.savedConfig.userIds.length) {
        this.selectedEmployee = this.employeeList.filter((e: { id: number }) => this.savedConfig.userIds.includes(e.id));
      }
    });
  }

  onSelectGrade() {
    this.savedConfig.userIds = [];
    this.loadEmployeesForGrades();
  }

  onDeSelectGrade() {
    this.onSelectGrade();
  }

  onSelectAllGrade() {
    console.log('Select All grades..');
    this.savedConfig.userIds = [];
    setTimeout(() => {
      this.loadEmployeesForGrades();
    }, 250);
  }

  onDeSelectAllGrade() {
    this.savedConfig.userIds = [];
    setTimeout(() => {
      this.loadEmployeesForGrades();
    }, 250);
  }

  // dropdwon for project
  projectList: any = [];
  selectedProject: any = [];
  // selectedProject:any=[]
  onSelectProduct() {}

  onDeSelectProduct() {}

  onSelectAllProduct() {}

  onDeSelectAllProduct() {}

  // dropdwon for Employee
  employeeList: any = [];
  selectedEmployee: any = [];
  onSelectEmployee() {}

  onDeSelectEmployee() {}

  onSelectAllEmployee() {}

  onDeSelectAllEmployee() {}

  // ------------------------ Save Report Config ------------------------

  saveReportConfig() {
    if (!this.selectedEmployee.length) {
      this.toastr.error('Please select at least one employee');
      return;
    }

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      grades: this.selectGrade.map(g => g.name),
      userIds: this.selectedEmployee.map((e: { id: any }) => e.id)
    };

    if (this.reportConfigId) {
      payload.id = this.reportConfigId;
    }

    this.httpService.callPostService(this.config.saveDwmReportConfig, payload).subscribe(() => {
      this.toastr.success(this.reportConfigId ? 'Updated successfully' : 'Saved successfully');
      this.dialogRef.close(true);
    });
  }
}
